import { cn } from '@/lib/utils';

interface ColorSwatchesProps {
  colors: string[];
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function ColorSwatches({ colors, size = 'md', className }: ColorSwatchesProps) {
  if (!colors || colors.length === 0) {
    return (
      <div
        className={cn(
          'rounded border border-border bg-background-subtle',
          sizeClasses[size],
          className
        )}
      />
    );
  }

  if (colors.length === 1) {
    return (
      <div
        className={cn(
          'rounded border border-border',
          sizeClasses[size],
          className
        )}
        style={{ backgroundColor: colors[0] }}
        title={colors[0]}
      />
    );
  }

  // Multiple colors - show as gradient or split
  if (colors.length === 2) {
    return (
      <div
        className={cn(
          'rounded border border-border overflow-hidden',
          sizeClasses[size],
          className
        )}
        style={{
          background: `linear-gradient(135deg, ${colors[0]} 50%, ${colors[1]} 50%)`,
        }}
        title={colors.join(' / ')}
      />
    );
  }

  // 3+ colors - show as gradient
  const gradientStops = colors
    .map((color, i) => `${color} ${(i / (colors.length - 1)) * 100}%`)
    .join(', ');

  return (
    <div
      className={cn(
        'rounded border border-border overflow-hidden',
        sizeClasses[size],
        className
      )}
      style={{
        background: `linear-gradient(135deg, ${gradientStops})`,
      }}
      title={colors.join(' / ')}
    />
  );
}
